import Client from '~/types/api/api-module';
import ApiOptions from '../api-options';

const SUBSCRIPTION_URL = `${process.env.API_V4_HOST}/mitra/me`;

export default Client.wrap({
  retrieveSubscriptionInfo(packageName: string) {
    return this.get(`${SUBSCRIPTION_URL}/subscriptions/${packageName}`, 'user', new ApiOptions());
  },

  updateSubscriptionRenewalStatus(packageName: string, status: string, reason: string) {
    const requestPayload = {
      reason: reason || null,
    };

    return this.post(`${SUBSCRIPTION_URL}/subscriptions/${packageName}/renewal/${status}`, 'user', new ApiOptions({ requestPayload }));
  },
});
